"use client"
import { useTransitionRouter } from "next-view-transitions"
import { useEffect, useRef } from "react";
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import sanitizeHtml from "sanitize-html"
import { slideInOut } from "@/app/lib/gsapAnimation"


gsap.registerPlugin(ScrollTrigger)

export default function ParallaxSlider({insights}) {
  const sliderRef = useRef(null)
  const sectionRef = useRef(null)

  const transitionRouter = useTransitionRouter()

  useEffect(() => {
    const slider = sliderRef.current
    const sliderTitle = slider.querySelectorAll(".slider-title")
    const section = sectionRef.current
    const images = slider.querySelectorAll(".parallax-image")
    const imageWrapper = slider.querySelector(".image-wrapper")

    // Assign images
/*     images.forEach((img, index) => {
      img.style.backgroundImage = `url(./parallax/p${index + 1}.jpeg)`
    }) */

    const totalWidth = imageWrapper.scrollWidth
    const viewportWidth = window.innerWidth
    const scrollDistance = totalWidth - viewportWidth

    // Set section height to allow full horizontal scroll
    gsap.set(section, {
      height: scrollDistance + window.innerHeight
    })

    
    
    gsap.set(sliderTitle, {
      opacity: 1,
      immediateRender: true
    })

    // Animate horizontal scroll of the slider
    gsap.to(slider, {
      x: () => `-${scrollDistance}px`,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top+=200 top",
        end: () => `+=${scrollDistance + 10}`,
        scrub: true
        /*         pin: true, */
        /*         anticipatePin: 1, */
      }
    })

    // Animate individual images with parallax
    images.forEach((img, index) => {
       gsap.to(img, {
         x: () => `${(index + 1) * 100}px`,
         ease: "none",
         scrollTrigger: {
           trigger: section,
           start: "top top",
           end: () => `+=${scrollDistance}`,
           scrub: true
         }
       })
     })

  }, [])

  return (
    <section className="bg-black">
      <div ref={sectionRef} className="relative top-0 left-0 w-full">
        <div className="container pt-32">
          <h2 className="text-white">Some insights you may like</h2>
        </div>
        <div className="sticky top-0 h-screen overflow-hidden">
          <div ref={sliderRef} className="absolute top-0 left-0 h-full w-[2800px]">
            <div className="image-wrapper absolute top-[10%] h-[60%] w-full flex justify-around group">
              {insights.map((insight, index) => {
                return (
                  <div key={index} className="relative w-[400px] h-full overflow-hidden bg-black transition-all duration-200 ease-linear group-hover:opacity-75 hover:!opacity-100">
                    <a
                      onClick={e => {
                        e.preventDefault()
                        transitionRouter.push(`/insights/${insight.slug}`, { onTransitionReady: slideInOut })
                      }}
                      title="Insights page"
                    >
                      <div
                        className="parallax-image absolute w-[600px] h-full bg-cover bg-center"
                        style={{
                          left: `${-100 * (index + 1)}px`,
                          backgroundColor: "#ffffff",
                          backgroundImage: `url(${insight._embedded["wp:featuredmedia"][0]?.source_url}`
                        }}
                      />
                      <div className="text-white fixed bottom-[20vh] flex flex-col  slider-title opacity-0">
                        <h3 className="text-2xl font-semibold max-w-[400px]" dangerouslySetInnerHTML={{ __html: sanitizeHtml(insight?.title.rendered) }} />
                      </div>
                    </a>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}